module.exports = __webpack_public_path__ + "img/vinheta.a06aaed4.png";